import { useClientTranslation } from '@/lib/core/i18n';

interface OpeningHoursItem {
  day?: string | null;
  timeInterval?: string | null;
}

interface OpeningHoursBlockProps {
  items?: OpeningHoursItem[] | null;
}

export function OpeningHoursBlock({ items }: OpeningHoursBlockProps) {
  const t = useClientTranslation();

  if (!items?.length) return null;

  return (
    <div className="border-jncquoi-neutral-200 flex flex-col border-t px-4 pt-2">
      <div className="flex w-full items-center justify-between">
        <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] font-semibold tracking-[0.5px] uppercase">
          {t('App.Explore.OpeningHours')}
        </span>
        <div className="size-11" />
      </div>

      <div className="flex flex-col">
        {items.map((item, i) => (
          <div key={i} className="flex items-start justify-between gap-6 pb-4">
            <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 w-[60%] text-[16px] tracking-[0.5px]">
              {item.day}
            </p>
            <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-right text-[16px] tracking-[0.5px]">
              {item.timeInterval}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
